<template>
  <PostGalleryView
    @reorder="emitReorder"
    :post="post"
    :view-context="viewContext"
  >
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="attrs">
        <GalleryShowMore :size="size" :total-elements="totalElements" />
      </div>
    </template>
  </PostGalleryView>
</template>

<script lang="ts">
import { defineComponent, inject, PropType } from "vue"
import { ViewContext } from "concerns/useContextName"
import TextBody from "components/UI/TextBody.vue"
import PostGalleryView from "features/posts/gallery/PostGalleryView.vue"
import { Post } from "suus-api"
import GalleryShowMore from "features/gallery/GalleryShowMore.vue"

export default defineComponent({
  name: "PostGalleryShowMore",
  components: { PostGalleryView, TextBody, GalleryShowMore },
  props: {
    post: { type: Object as PropType<Post>, required: true },
    totalElements: { type: Number, required: true },
    size: { type: Number, default: 128 },
  },
  setup(props, { emit }) {
    const viewContext: ViewContext = inject("viewContext")
    if (viewContext === undefined) throw new Error("viewContext is undefined")

    const emitReorder = (event: { id: number; index: number }) => {
      emit("reorder", event)
    }

    return {
      viewContext,
      emitReorder,
    }
  },
})
</script>
